import { defineNuxtPlugin } from '#app'
import NProgress from "nprogress";

export default defineNuxtPlugin((nuxtApp) => {
    // 客户端动态加载 nprogress CSS，不阻塞首屏渲染
    if (process.client) {
        // 使用 CSS-in-JS 方式注入样式，避免额外的网络请求
        const style = document.createElement('style');
        style.textContent = `
            #nprogress { pointer-events: none; }
            #nprogress .bar { background: #29d; position: fixed; z-index: 1031; top: 0; left: 0; width: 100%; height: 2px; }
            #nprogress .peg { display: block; position: absolute; right: 0; width: 100px; height: 100%; box-shadow: 0 0 10px #29d, 0 0 5px #29d; opacity: 1; transform: rotate(3deg) translate(0px, -4px); }
            #nprogress .spinner { display: block; position: fixed; z-index: 1031; top: 15px; right: 15px; }
            #nprogress .spinner-icon { width: 18px; height: 18px; box-sizing: border-box; border: solid 2px transparent; border-top-color: #29d; border-left-color: #29d; border-radius: 50%; animation: nprogress-spinner 400ms linear infinite; }
            @keyframes nprogress-spinner { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `;
        document.head.appendChild(style);
    }

    nuxtApp.hooks.hook("page:start", () => {
        NProgress.start();
    });
    nuxtApp.hooks.hook("page:finish", () => {
        NProgress.done();
    });
})
